/**
 * Tolerância do clique no mapa, em px de tela, conforme o ponteiro.
 *
 * O dedo cobre mais que a ponta do cursor, e de longe os símbolos encolhem
 * (`escalaDoZoom.ts`): o menor alvo, com os 6 px do mouse, ficava em ~16×19 px.
 * Com 10 px no toque ele passa a ~24×27 px.
 *
 * A decisão é pelo TIPO DO PONTEIRO do evento, e não pela largura da tela: um
 * notebook com tela de toque usa 10 px no dedo e 6 px no mouse, na mesma
 * sessão. Caneta é precisa como o mouse.
 *
 * Com a tolerância maior, mais de um símbolo pode cair no raio do toque. A
 * escolha não muda: primeiro a camada de maior zIndex; na mesma camada, o
 * símbolo mais próximo do ponto tocado (o OpenLayers entrega os acertos por
 * distância, e os focos escolhem o mais próximo no teste próprio deles).
 */
export const TOLERANCIA_MOUSE = 6;
export const TOLERANCIA_TOQUE = 10;

/** Tolerância para o evento que originou o clique (`evt.originalEvent` do OpenLayers). */
export function toleranciaDoClique(evento: object | null | undefined): number {
  const tipo = evento && 'pointerType' in evento ? evento.pointerType : undefined;
  return tipo === 'touch' ? TOLERANCIA_TOQUE : TOLERANCIA_MOUSE;
}
